import React, { FC } from 'react';
import Link from 'next/link';
import Image from 'next/image';

import blogPosts from '../../../src/mock/blog/blogPosts';

import styles from './styles.module.scss';

const MainBlogList: FC = () => {
  return (
    <div className="container">
      <div className={styles.blog}>
        {blogPosts.slice(0, 6).map((post) => (
          <div key={post.title} className={styles.post}>
            <Link href={`/blog/${post.slug}`} className={styles.postLink}>
              <div className={styles.postImage}>
                <Image src={post.cover} alt={post.title} />
              </div>
            </Link>
            <Link href={`/blog/${post.slug}`} className={styles.postTitle}>
              {post.title}
            </Link>
            <div className={styles.postDate}>{post.created_at}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { MainBlogList };
